import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  Container,
  Dropdown,
  Modal,
  Nav,
  Navbar,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { apiService } from "../service/api.service";
import { errorHandling, UtctolocalDate } from "../config/config";
import moment from "moment";

const Header = () => {
  const [show, setShow] = useState(false);
  const [statusProfile, setstatusProfile] = useState(
    localStorage.getItem("profile_status")
  );
  const [profileCompleted, setprofileCompleted] = useState();
  const [notifyCount, setnotifyCount] = useState();
  const [notificationData, setnotificationData] = useState();
  const [total, settotal] = useState();

  const handleClose = () => setShow(false);
  const loginToken = localStorage.getItem("web_token");
  const logout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };
  const location = useLocation();
  const profileImage = useSelector((state) => state.reducer.profileImage);

  useEffect(() => {
    if (
      (location.pathname == "/dashboard" ||
        location.pathname == "/transactions" ||
        location.pathname == "/create-profile" ||
        location.pathname == "/update-profile" ||
        location.pathname == "/product-mangement" ||
        location.pathname == "/order-mangement") &&
      !localStorage.getItem("web_token")
    ) {
      window.location.href = "/";
    }
    if (loginToken) {
      getNotification(0, 20);
      GetProfile();
    }
  }, []);

  const EditProfileData = () => {
    window.location.href = "/update-profile";
    setShow(false);
  };
  const varifyAccount = () => {
    apiService
      .stripLink()
      .then((res) => {
        console.log(res.data.data.url);
        window.open(res.data.data.url, "_blank");
      })
      .catch((err) => {
        // setLoader(false)
        // setupdateShow(true)
      });
  };
  const addBankDetail = () => {
    window.location.href = "/bank-details";
    setShow(false);
  };
  const getNotification = (page, size) => {
    apiService
      .notifications(page, size)
      .then((res) => {
        setnotificationData(res.data.data.list);
        settotal(res.data.data.total);
      })
      .catch((err) => {
        // setupdateShow(true)
      });
  };

  const GetProfile = () => {
    apiService
      .GetProfile()
      .then((res) => {
        setstatusProfile(res.data.data.user.status);
        if (
          res.data.data.user.firstName &&
          res.data.data.user.firstName != null
        ) {
          setprofileCompleted(res.data.data.user.firstName);
        }
        setnotifyCount(res.data.data.user.notifyCount);
        localStorage.setItem("profile_status", res.data.data.user.status);
      })
      .catch((err) => {
        errorHandling(err.response.status);
      });
  };

  const homeHref = localStorage.getItem("web_token")
    ? location.pathname !== "/dashboard" ? "/dashboard" : undefined
    : location.pathname !== "/" ? "/" : undefined;
  const isHomeActive =
    location.pathname == "/dashboard" || location.pathname == "/";

  return (
    <>
      <header className="sm-header">
        <Navbar expand="lg">
          <Container>
            <Navbar.Brand href={homeHref} className="sm-brand">
              <span className="sm-brand-text">
                <img className="logo-image" src={require("../assets/images/logo.png")} alt="GoCart" />
              </span>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="navbarScroll" className="sm-toggler" />

            <Navbar.Collapse id="navbarScroll">
              <Nav className="sm-nav mx-auto">
                <Nav.Link href={homeHref} className={isHomeActive ? "active" : ""}>
                  Home
                </Nav.Link>
                <Nav.Link href="#services">Services</Nav.Link>
                <Nav.Link href="#marketplace">Marketplace</Nav.Link>
                <Nav.Link href="#testimonials">Testimonials</Nav.Link>
                <Nav.Link
                  href="/contact-us"
                  className={location.pathname == "/contact-us" ? "active" : ""}
                >
                  Contact
                </Nav.Link>
              </Nav>

              <div className="sm-nav-actions">
                {loginToken && (
                  <Nav.Link className="position-relative head-top-notifications">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="unset"
                        id="dropdown-basic"
                        className="sm-icon-btn"
                      >
                        {notifyCount > 0 && (
                          <span className="dot-notification"></span>
                        )}
                        <img
                          className="desktop-view"
                          src={require("../assets/images/notification.svg").default}
                          alt="Notifications"
                        />
                        <span className="mobile-view">Notifications</span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <div className="notification-content-top">
                          {notificationData &&
                            notificationData.map((data, index) => {
                              let orderData = JSON.parse(data.extras);
                              return (
                                <Dropdown.Item key={index}>
                                  <div
                                    onClick={() => {
                                      window.location.href =
                                        "/order-mangement/order-details/" +
                                        orderData.orderId;
                                    }}
                                  >
                                    {data.description}
                                    <p>
                                      {moment(UtctolocalDate(data?.time)).format(
                                        "hh:mm a, DD MMM YYYY"
                                      )}
                                    </p>
                                  </div>
                                </Dropdown.Item>
                              );
                            })}
                          {notificationData && notificationData.length == 0 && (
                            <Dropdown.Item>
                              <div className="nodata centre">
                                <img
                                  className=""
                                  src={require("../assets/images/no-data-found.png")}
                                  alt="No data found"
                                />
                                <span>No data Found</span>
                              </div>
                            </Dropdown.Item>
                          )}
                        </div>
                        {total && total > 20 && (
                          <a
                            href=""
                            onClick={() => {
                              window.location.href = "/notifications";
                            }}
                            className="notifications-view"
                          >
                            View More
                          </a>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Nav.Link>
                )}

                {!loginToken && (
                  <>
                    <Nav.Link href="/login" className="sm-signin-link">
                      Sign In
                    </Nav.Link>
                    <Nav.Link href="/signup" className="sm-join-btn">
                      Join Marketplace
                    </Nav.Link>
                  </>
                )}

                {loginToken && (
                  <Nav.Link href="#action2">
                    <Dropdown>
                      <Dropdown.Toggle variant="unset" id="dropdown-basic" className="sm-avatar-btn">
                        {profileImage || localStorage.getItem("profile_img") ? (
                          <img
                            className="default-profile-img"
                            src={
                              profileImage
                                ? profileImage
                                : localStorage.getItem("profile_img")
                            }
                            alt="Profile"
                          />
                        ) : (
                          <img
                            className="default-profile-img"
                            src={require("../assets/images/user-default.png")}
                            alt="Profile"
                          />
                        )}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          href={
                            location.pathname == "/my-profile"
                              ? "javascript:void(0)"
                              : "/my-profile"
                          }
                        >
                          My Profile
                        </Dropdown.Item>
                        <Dropdown.Item
                          href={
                            location.pathname == "/bank-details"
                              ? "javascript:void(0)"
                              : "/bank-details"
                          }
                        >
                          Bank Details
                        </Dropdown.Item>
                        <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Nav.Link>
                )}
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>

      {/* alert messages */}
      <Container>
        {statusProfile == "Incomplete_Profile" && !profileCompleted && (
          <Alert variant="warning" onClose={() => setShow(false)} dismissible>
            <Alert.Heading>
              <i className="fa-solid fa-circle-exclamation"></i> Alert:
            </Alert.Heading>
            <p className="p-0 m-0">
              Kindly submit your profile data for admin approval before
              proceeding to create products.
            </p>
          </Alert>
        )}
        {statusProfile == "Pending" && profileCompleted && (
          <Alert variant="warning" onClose={() => setShow(false)} dismissible>
            <Alert.Heading>
              <i className="fa-solid fa-circle-exclamation"></i> Alert:
            </Alert.Heading>
            <p className="p-0 m-0">
              You can't add products. Your account is under admin approval.
            </p>
          </Alert>
        )}
        {statusProfile == "Incomplete_Profile" && profileCompleted && (
          <Alert variant="warning" onClose={() => setShow(false)} dismissible>
            <Alert.Heading>
              <i className="fa-solid fa-circle-exclamation"></i> Alert:
            </Alert.Heading>
            <p className="p-0 m-0">
              Your profile information is incomplete. Please add your bank
              details.
              <span onClick={addBankDetail} className="edit_btn">
                Click here to add.
              </span>
            </p>
          </Alert>
        )}
        {statusProfile == "Stripe_Details_Pending" && profileCompleted && (
          <Alert variant="warning" onClose={() => setShow(false)} dismissible>
            <Alert.Heading>
              <i className="fa-solid fa-circle-exclamation"></i> Alert:
            </Alert.Heading>
            <p className="p-0 m-0">
              Your bank account verification is pending. Please complete the
              verification process for your bank account.
              <span onClick={varifyAccount} className="edit_btn">
                Click here to verify.
              </span>
            </p>
          </Alert>
        )}
        {statusProfile == "Stripe_Verification_Pending" && profileCompleted && (
          <Alert variant="warning" onClose={() => setShow(false)} dismissible>
            <Alert.Heading>
              <i className="fa-solid fa-circle-exclamation"></i> Alert:
            </Alert.Heading>
            <p className="p-0 m-0">
              Your bank account verification is currently being processed.
              Once your account is verified, you will be able to proceed.
            </p>
          </Alert>
        )}
        {statusProfile == "Reject" && (
          <Alert variant="success" onClose={() => setShow(false)} dismissible>
            <Alert.Heading>
              <i className="fa-solid fa-circle-exclamation"></i> Alert:
            </Alert.Heading>
            <p className="p-0 m-0">
              Your account verification request has been rejected by the
              admin. Kindly re-submit your profile data for further
              processing.{" "}
              <span onClick={EditProfileData} className="edit_btn">
                Update Profile.
              </span>
            </p>
          </Alert>
        )}
      </Container>

      {/* logout modal */}
      <Modal show={show} onHide={handleClose} className="modal-success" centered>
        <Modal.Body>
          <div className="modal-success-body text-center">
            <img
              className=""
              src={require("../assets/images/logout-mark.svg").default}
              alt="Logout"
            />
            <p>Are you sure you want to logout?</p>
            <Button variant="primary" className="green-btn" onClick={logout}>
              Yes
            </Button>
            <Button
              variant="primary"
              className="green-btn green-outline-btn"
              onClick={handleClose}
            >
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Header;
